import { Directive, Inject, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { HomePageContent } from '@epicuro-next/data/merchandise';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Directive({
  standalone: true,
})
export class SetDefaultTitle implements OnDestroy {
  public destroy$ = new Subject<void>();
  public HomePageContent = HomePageContent;

  constructor(
    private titleService: Title,
    private router: Router,
    @Inject(ENVIRONMENT_SETTINGS)
    private environmentSettings: EnvironmentSettings,
  ) {
    this.onRouteEvents();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public setTitle() {
    if (this.environmentSettings.applicationTitle) {
      this.titleService.setTitle(this.environmentSettings.applicationTitle);
    }
  }

  private onRouteEvents() {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter<NavigationStart>((event) => event instanceof NavigationStart),
      )
      .subscribe(() => {
        this.setTitle();
      });
  }
}
